import { useContext } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { DEFAULT_ERROR_MESSAGE } from '../../Base.constants';
import { ToastContext } from '../../context/ToastContext';
import { createSession } from '../../services/chat/createSession.service';
import { queryKeys } from '../queryKeyFactory';
import { useTrackUsage } from '../usage/track';

export const useSessionId = (enabled: boolean): UseQueryResult<string, Error> => {
  const toast = useContext(ToastContext);
  const trackUsage = useTrackUsage();

  return useQuery(
    queryKeys.chat.createSession,
    async () => {
      const res = await createSession();
      trackUsage.createSession({ sessionId: res.rdr_auth_chatbot });

      return res.rdr_auth_chatbot;
    },
    {
      enabled,
      onError: () => {
        toast.error(DEFAULT_ERROR_MESSAGE);
      },
    }
  );
};
